import React, {useState, useEffect, useRef} from "react";
import {
    LoginErrorText, ErrorText, ResetTextStyle, Link, LoginButton, LoginInput, Label, Field, InputWrapper,
} from "./styles/loginStyles";
import {ButtonText} from "BaseComponents/Button";
import {PageTransition} from "Animations";
import {Validate} from "Framework/helpers/FormFieldHelper/";

const ForgetPassword = ({
                            onChange,
                            UserNameError,
                            MobilePhoneError,
                            GeneralError,
                            Back,
                            SendResetMailSuccessText,
                            SendResetSMSSuccessText,
                            ResetText,
                            SendEmail,
                            SendSms,
                            toggleShowForgetPassword,
                            SendSmsOrEmail,
                            EmailPhone,
                            getHeaders,
                            validate,
                            CurrentPageId,
                        }) => {
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef(null);
    const [inputError, setInputError] = useState(false);
    const [sendMailOrSmsError, setSendMailOrSmsError] = useState(false);
    const [sendMailOrSmsSuccess, setSendMailOrSmsSuccess] = useState(false);
    const [errorText, setErrorText] = useState(GeneralError);

    const [isEmail, setIsEmail] = useState(false);

    const emailValidation = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const send = (e) => {
        e.preventDefault();

        let input = inputRef.current;
        let isError = false;

        if (isEmail && !Validate(input.value, "email")) {
            setInputError(true);
            isError = true;
        }

        if (!isError) {
            setIsLoading(true);
            let bodyJson = JSON.stringify({
                Email: input.value, IsEmail: isEmail, CurrentPageId
            });
            fetch(`/user/reset`, {
                method: "POST", headers: getHeaders(), body: bodyJson,
            })
                .then((response) => response.json())
                .then(({Status, Message, User}) => {
                    if (Status) {
                        setSendMailOrSmsSuccess(true);
                    } else {
                    }
                    setIsLoading(false);
                }, (error) => {
                    setIsLoading(false);
                    setSendMailOrSmsError(true);
                });
        }
    };

    const checkIfEmailOrPhoneNumber = (elm, type, errorFunc) => {
        let isEmail = emailValidation(elm.value);
        if (isEmail) {
            type = "email";
            setIsEmail(true);
            setErrorText(UserNameError);
        } else {
            setErrorText(GeneralError);
            setIsEmail(false);
        }
        onChange(elm, type, errorFunc);
    };

    return (<PageTransition transitionDuration="400" delay="100" wide>
            <InputWrapper>
                <Field>
                    <Label>{EmailPhone}</Label>
                    <LoginInput
                        disabled={isLoading}
                        ref={inputRef}
                        type="input"
                        error={inputError}
                        aria-invalid={inputError}
                        onChange={(inputRef) => checkIfEmailOrPhoneNumber(inputRef.currentTarget, "email", setInputError)}
                    />
                    {inputError && <ErrorText>{errorText}</ErrorText>}
                </Field>
                <LoginButton
                    onClick={(e) => send(e)}
                    width="100%"
                    pageloading={isLoading}
                    margin="1rem 0 0 0"
                >
                    {!isLoading && (<ButtonText forcedFontSize="24px">
                            {isEmail ? SendEmail : SendSmsOrEmail}
                        </ButtonText>)}
                </LoginButton>
                {sendMailOrSmsError && (<LoginErrorText>
                        Något gick fel vid inloggning, var god försök igen
                    </LoginErrorText>)}
                <ResetTextStyle success={sendMailOrSmsSuccess}>
                    {sendMailOrSmsSuccess ? isEmail ? SendResetMailSuccessText : isPhoneNumber ? SendResetSMSSuccessText : "" : ResetText}
                </ResetTextStyle>
                <Link
                    margin="1rem 0 0 0"
                    onClick={(e) => toggleShowForgetPassword(e)}
                    href="/"
                >{`< ${Back}`}</Link>
            </InputWrapper>
        </PageTransition>);
};

export default ForgetPassword;
